import { lazy } from 'react';

export const SubmitMatchDecisionForm = lazy(
  () => import('./SubmitMatchDecisionForm'),
);
